import React from 'react';
import { UserAvatar } from '../commons/UserInfo';

export interface CerradoPorUsuario {
  id: number;
  nombre?: string | null;
  apellido?: string | null;
  nombreCompleto?: string | null;
}

function fmtCerrado(value?: string | null): string {
  if (!value) return '';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return value;
  return d.toLocaleString('es-MX', { dateStyle: 'short', timeStyle: 'short' });
}

export function CerradoPor({
  usuario,
  cerrado,
}: {
  usuario?: CerradoPorUsuario | null;
  cerrado?: string | null;
}) {
  if (!usuario?.id) return null;

  const fullName =
    `${usuario.nombre ?? ''} ${usuario.apellido ?? ''}`.trim()
    || (usuario.nombreCompleto ?? '').trim()
    || `#${usuario.id}`;
  const cerradoLabel = fmtCerrado(cerrado);

  return (
    <div style={s.root} aria-label="Cerrado por">
      <span style={s.label}>Cerrado por:</span>
      <UserAvatar usuario={usuario} size={22} />
      <div style={s.identity}>
        <span style={s.name}>{fullName}</span>
        {cerradoLabel && <span style={s.when}>{cerradoLabel}</span>}
      </div>
    </div>
  );
}

const s: Record<string, React.CSSProperties> = {
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
    minWidth: 0,
  },
  label: {
    fontSize: 11,
    color: 'var(--crm-text-secondary)',
    whiteSpace: 'nowrap',
  },
  identity: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
    minWidth: 0,
  },
  name: {
    fontSize: 12,
    fontWeight: 600,
    color: 'var(--crm-text-primary)',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  when: {
    fontSize: 11,
    color: 'var(--crm-text-secondary)',
    whiteSpace: 'nowrap',
  },
};
